import axios from "axios";

export const setupAxios = (companyToken) => {
  axios.interceptors.request.use(
    (config) => {
      config.headers["Api-Token"] = companyToken;
      return config;
    },
    (err) => Promise.reject(err)
  );
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response) {
        if (error.response.status === 401) {
          alert("Unauthorized API token.");
        }
        else if ([500, 404].includes(error.response.status)) {
          alert("Server Error!");
        }
      }
      return Promise.reject(error);
    }
  );
};
